import { memo, useEffect } from 'react';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';
import { Box, Image, useLayout, useStyle, ViewStyle } from '@bonanza-social/moonlight';
import {
  IMAGE_SIZE,
  IMAGES_GAP,
  STATUSES,
} from './StatusGemsLineAnimation.content';

function StatusGemsLineAnimation() {
  const gap = Number(useStyle<ViewStyle>({ gap: IMAGES_GAP }).gap);
  const totalSize = STATUSES.length * (IMAGE_SIZE + gap) - gap;
  const [layout, onLayout] = useLayout();
  const animatedValue = useSharedValue(0);
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: animatedValue.value }],
  }));

  useEffect(() => {
    animatedValue.value = -layout.width;
    animatedValue.value = withRepeat(
      withTiming(totalSize, { duration: 10000, easing: Easing.linear }),
      -1,
    );
  }, [layout.width, totalSize, animatedValue]);

  return (
    <Box
      onLayout={onLayout}
      animatedStyle={animatedStyle}
      maxHeight="100%"
      flexDirection="row-reverse"
      marginVertical="auto"
      gap="space-1000"
    >
      {STATUSES.map((status) => (
        <Box
          key={status}
          width={IMAGE_SIZE}
          height={IMAGE_SIZE}
          maxHeight="100%"
        >
          <Image name={`status.${status}Gem`} width="100%" height="100%" />
        </Box>
      ))}
    </Box>
  );
}

export default memo(StatusGemsLineAnimation);
